import { cn } from '@talentmesh/ui/lib/utils';
import { ReactNode } from 'react';

interface CTMonitoringFunctionalityDisabledProps {
    icon: ReactNode;
    message: string;
    className?: string;
}

function CTMonitoringFunctionalityDisabled({ icon, message, className }: CTMonitoringFunctionalityDisabledProps) {
    return (
        <div className={cn('border-border flex flex-row items-center justify-center gap-4 border', className)}>
            {icon}
            <h4 className="text-muted-foreground flex">{message}</h4>
        </div>
    );
}

export default CTMonitoringFunctionalityDisabled;
